import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './AdminModal.css';

function AdminModal({ open, onClose, title, children, footer, width }) {
  useEffect(() => {
    if (!open) return;
    const handleEsc = (e) => { if (e.key === 'Escape' && onClose) onClose(); };
    document.addEventListener('keydown', handleEsc);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open) return null;

  return ReactDOM.createPortal(
    <div className="admin-modal-portal">
      <div className="admin-modal-backdrop" onClick={onClose} />
      <div className="admin-modal-positioner">
        <div className="admin-modal-container" style={width ? { minWidth: width, maxWidth: width } : undefined} onClick={e => e.stopPropagation()}>
          {title && (
            <div className="admin-modal-header">
              <h2 className="admin-modal-header-title">{title}</h2>
              {onClose && <button className="admin-modal-header-close" onClick={onClose}>&times;</button>}
            </div>
          )}
          <div className="admin-modal-body">{children}</div>
          {footer && <div className="admin-modal-footer">{footer}</div>}
        </div>
      </div>
    </div>,
    document.body
  );
}

export default AdminModal;
